module.exports = __webpack_public_path__ + "img/icon_3_15.c880df60.png";